import * as ATypes from "../../shared/actionTypes";

export const toggleSideMenu = () => {
  return {
    type: ATypes.TOGGLE_SIDE_MENU
  }
};


